export const RandomColor = (opacity?: number): string => {
  const getRandomInt = (min: number, max: number)  => {
    return Math.floor(Math.random() * (max - min)) + min
  }

  return `rgba(${ getRandomInt(0, 255) },${ getRandomInt(0, 255) },${ getRandomInt(0, 255) }, ${ opacity ?? 1 })`
}
